import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  ListItemButton,
  MenuItem,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import {
  HiOutlineUser,
  HiOutlineEnvelope,
  HiOutlinePhone,
} from 'react-icons/hi2';
import BookingData from '../../../Assets/Dataa/BookingData';
import DietaryOptions from '../../../Main/Components/Common/DietaryOptions';
import CustomInput from '../../../Main/Components/Custom/CustomInput';
import WidgetFormField from './WidgetFormField';
import WidgetGuestForm from './WidgetGuestForm';
import WidgetFormFieldSelect from './WidgetFormFieldSelect';
import { useGetQuery } from '../../../hooks/useQuery';
import { LuUser } from 'react-icons/lu';

const inputFieldSx = (theme) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    '& fieldset': { borderColor: theme.palette.divider },
  },
});

const getFieldSx = (theme) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    bgcolor: 'background.paper',
    fontSize: '13px',
    '& fieldset': { borderColor: theme.palette.divider },
    '&:hover fieldset': { borderColor: theme.palette.text.secondary },
    '&.Mui-focused fieldset': { borderColor: 'primary.main' },
  },
});

const GuestDetailsPanel = ({
  guestTitle,
  setGuestTitle,
  birthMonth,
  birthDay,
  setBirthMonth,
  setBirthDay,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  email,
  handleEmailChange,
  emailError,
  phoneNumber,
  handleMobileChange,
  mobileError,
  nameRef,
  lastNameRef,
  emailRef,
  phoneRef = null,
  guest,
  handleFormSubmit,
  occasion,
  setOccasion,
  otherOccasions,
  setOtherOccasions,
  month,
  setMonth,
  day,
  setDay,
  dobError,
  IS_NEST,
  setDietary,
  specialRequest,
  setSpecialRequest,
  currentColor,
  submitLabel,
  onSubmit,
  isSubmitDisabled,
}) => {
  const theme = useTheme();
  const canSubmit = !isSubmitDisabled;

  const { data } = useGetQuery([''], '/guestservice/get_guest_titles');

  const [titles, setTitles] = useState([]);

  useEffect(() => {
    if (data) {
      setTitles(data?.result);
    }
  }, [data]);

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '18px',
        p: { xs: 2.5, sm: 3 },
        boxShadow:
          theme.palette.mode === 'dark'
            ? 'none'
            : '0 18px 45px rgba(16, 24, 40, 0.08)',
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: '24px', md: '28px' },
          fontWeight: 900,
          lineHeight: 1.1,
          color: 'text.primary',
        }}
      >
        Guest Details
      </Typography>
      <Typography sx={{ color: 'text.secondary', fontSize: '13px', mt: 0.75 }}>
        Please provide your contact information
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography sx={{ fontWeight: 700, fontSize: '12px', mt: -0.4 }}>
              Title
            </Typography>
            <Box sx={{ position: 'relative', ...getFieldSx(theme), mt: -0.5 }}>
              <CustomInput
                defaultValue={''}
                select
                value={guestTitle}
                onChange={(e) => {
                  if (setGuestTitle) {
                    setGuestTitle(e.target.value);
                  }
                }}
                fullWidth
                small
                InputProps={{
                  style: {
                    paddingLeft: undefined,
                    borderRadius: '10px',
                    height: '48px',
                  },
                }}
              >
                <MenuItem value={''}>Select</MenuItem>
                {titles.map((day, idx) => (
                  <MenuItem value={day?.Name} key={idx}>
                    {day?.DisplayName}
                  </MenuItem>
                ))}
              </CustomInput>
            </Box>
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <Typography sx={{ fontWeight: 700, fontSize: '12px', mt: -0.4 }}>
              Birthday <span className="text-[#d3d3d3]">(Day & Month)</span>
            </Typography>
            <Grid container columnSpacing={2} sx={{ mt: -0.5 }}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ position: 'relative', ...getFieldSx(theme) }}>
                  <CustomInput
                    defaultValue={0}
                    select
                    value={birthDay}
                    onChange={(e) => {
                      if (setBirthDay) {
                        setBirthDay(e.target.value);
                      }
                    }}
                    fullWidth
                    small
                    InputProps={{
                      style: {
                        paddingLeft: undefined,
                        borderRadius: '10px',
                        height: '48px',
                      },
                    }}
                  >
                    <MenuItem value={0}>Day</MenuItem>
                    {Array.from({ length: 31 }, (_, index) => index + 1).map(
                      (day) => (
                        <MenuItem value={day} key={day}>
                          {day}
                        </MenuItem>
                      ),
                    )}
                  </CustomInput>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ position: 'relative', ...getFieldSx(theme) }}>
                  <CustomInput
                    select
                    fullWidth
                    small
                    value={birthMonth}
                    defaultValue="Month"
                    onChange={(e) => {
                      if (setBirthMonth) {
                        setBirthMonth(e.target.value);
                      }
                    }}
                    InputProps={{
                      style: {
                        paddingLeft: undefined,
                        borderRadius: '10px',
                        height: '48px',
                      },
                    }}
                  >
                    <MenuItem value="Month">Month</MenuItem>
                    <MenuItem value="1">January</MenuItem>
                    <MenuItem value="2">February</MenuItem>
                    <MenuItem value="3">March</MenuItem>
                    <MenuItem value="4">April</MenuItem>
                    <MenuItem value="5">May</MenuItem>
                    <MenuItem value="6">June</MenuItem>
                    <MenuItem value="7">July</MenuItem>
                    <MenuItem value="8">August</MenuItem>
                    <MenuItem value="9">September</MenuItem>
                    <MenuItem value="10">October</MenuItem>
                    <MenuItem value="11">November</MenuItem>
                    <MenuItem value="12">December</MenuItem>
                  </CustomInput>
                </Box>
              </Grid>
            </Grid>
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <WidgetFormField
              label="First Name"
              required
              icon={<LuUser size={18} />}
              inputRef={nameRef}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WidgetFormField
              label="Last Name"
              required
              icon={<LuUser size={18} />}
              inputRef={lastNameRef}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </Grid>
          <Grid item lg={12} xs={12}>
            <WidgetFormField
              label="Email Address"
              required
              icon={<HiOutlineEnvelope size={18} />}
              inputRef={emailRef}
              value={email}
              onChange={handleEmailChange}
              error={!!emailError}
              helperText={emailError}
            />
          </Grid>
          <Grid item lg={12} xs={12}>
            <WidgetFormField
              label="Phone Number"
              required
              inputRef={phoneRef}
              value={phoneNumber}
              onChange={(value) => handleMobileChange(value)}
              error={!!mobileError}
              helperText={mobileError}
              type="phone_number"
            />
          </Grid>
        </Grid>

        <WidgetGuestForm
          onGuestListUpdate={handleFormSubmit}
          partySize={parseFloat(guest) || 1}
        />

        <Typography
          sx={{
            fontWeight: 800,
            fontSize: '14px',
            color: 'text.secondary',
            mt: 3,
            mb: 1.5,
          }}
        >
          What occasion are you celebrating?
        </Typography>
        <Grid container spacing={1.5}>
          {BookingData?.map((item, index) => {
            const isSelected = item?.title === occasion;
            return (
              <Grid item xs={6} sm={3} key={index}>
                <ListItemButton
                  selected={isSelected}
                  onClick={() => setOccasion(item?.title)}
                  sx={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    gap: 0.35,
                    p: 1.5,
                    height: 68,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: '12px',
                    bgcolor: 'background.paper',
                    ...(isSelected && {
                      border: '2px solid',
                      borderColor: currentColor.primary,
                      bgcolor: `${currentColor.primary}08`,
                    }),
                  }}
                >
                  <div
                    className={` ${isSelected ? 'text-primary' : 'text-gray-500'}`}
                  >
                    {item?.icon}
                  </div>
                  <Typography
                    sx={{
                      fontSize: '11px',
                      fontWeight: 700,
                      textAlign: 'center',
                      color: isSelected ? 'primary.main' : 'text.secondary',
                    }}
                  >
                    {item?.title}
                  </Typography>
                </ListItemButton>
              </Grid>
            );
          })}
        </Grid>

        <TextField
          variant="outlined"
          value={otherOccasions}
          onChange={(e) => setOtherOccasions(e.target.value)}
          label="Others?"
          fullWidth
          sx={{ mt: 2, ...inputFieldSx(theme) }}
          InputProps={{ style: { borderRadius: '10px', height: 48 } }}
        />

        {true && (
          <Box sx={{ mt: 2 }}>
            <Typography sx={{ fontWeight: 700, fontSize: '12px', mb: 1 }}>
              Date of Birth (Day & Month)
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                select
                error={dobError}
                fullWidth
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                sx={inputFieldSx(theme)}
              >
                <MenuItem value="">Month</MenuItem>
                {[
                  'January',
                  'February',
                  'March',
                  'April',
                  'May',
                  'June',
                  'July',
                  'August',
                  'September',
                  'October',
                  'November',
                  'December',
                ].map((m, i) => (
                  <MenuItem key={m} value={i + 1}>
                    {m}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                error={dobError}
                fullWidth
                value={day}
                onChange={(e) => setDay(e.target.value)}
                sx={inputFieldSx(theme)}
              >
                <MenuItem value="">Day</MenuItem>
                {Array.from({ length: 31 }, (_, i) => (
                  <MenuItem key={i + 1} value={i + 1}>
                    {i + 1}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Box>
        )}

        <Box sx={{ mt: 3 }}>
          <DietaryOptions updateDietary={(value) => setDietary(value)} />
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '12px',
              mb: 1,
              color: 'text.primary',
            }}
          >
            Do have any special request?
          </Typography>
          <CustomInput
            value={specialRequest}
            onChange={(e) => setSpecialRequest(e.target.value)}
            placeholder="Your input here"
            multiline
            fullWidth
            minRows={3}
            sx={{
              '& .MuiOutlinedInput-root': {
                bgcolor: 'background.paper',
                color: 'text.primary',
                '& fieldset': { borderColor: 'divider' },
                '&:hover fieldset': { borderColor: 'text.secondary' },
                '&.Mui-focused fieldset': { borderColor: 'primary.main' },
              },
              '& .MuiInputBase-input': { color: 'text.primary' },
              '& .MuiInputBase-input::placeholder': {
                color: 'text.secondary',
                opacity: 1,
              },
            }}
            InputProps={{
              style: { borderRadius: '10px', alignItems: 'flex-start' },
            }}
          />
        </Box>

        {dobError && (
          <Typography
            sx={{
              color: 'primary.main',
              fontSize: '12px',
              textAlign: 'center',
              mt: 1,
            }}
          >
            Please select your date of birth
          </Typography>
        )}

        <Button
          variant="contained"
          fullWidth
          disabled={!canSubmit}
          onClick={onSubmit}
          sx={{
            mt: 3,
            borderRadius: '10px',
            py: 1.6,
            fontSize: '14px',
            fontWeight: 900,
            bgcolor: canSubmit ? 'primary.main' : 'action.disabledBackground',
            color: canSubmit ? 'primary.contrastText' : 'text.disabled',
            boxShadow: 'none',
            '&:hover': {
              bgcolor: canSubmit ? 'primary.main' : 'action.disabledBackground',
              boxShadow: 'none',
              opacity: canSubmit ? 0.92 : 1,
            },
          }}
        >
          {submitLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default GuestDetailsPanel;
